import React from "react";

import HomeInfo from "./HomeInfo";
import HomePosition from "./HomePosition";
import HomeServices from "./HomeServices";
import HomePhotos from "./HomePhotos";

import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import HomeDescription from "./HomeDescription";
import HomePropertyInstruction from "../HomePropertyInstruction";


const HomeTabs = () => {
    const [value, setValue] = React.useState("0");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return <Card sx={{mt: 3}}>
        <Box sx={{width: '100%', typography: 'body1'}}>
            <TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <TabList onChange={handleChange}
                             aria-label="lab API tabs example"
                             variant="scrollable"
                             scrollButtons="auto">
                        <Tab label="Info" value="0"/>
                        <Tab label="Posizione" value="1"/>
                        <Tab label="Descrizione" value="2"/>
                        <Tab label="Foto Esterne" value="3"/>
                        <Tab label="Servizi Casa" value="4"/>
                        <Tab label="Regole Ospiti" value="5"/>
                    </TabList>
                </Box>
                <TabPanel value="0" sx={{p: 0}}><HomeInfo/></TabPanel>
                <TabPanel value="1" sx={{p: 0}}><HomePosition/></TabPanel>
                <TabPanel value="2" sx={{p: 0}}><HomeDescription/></TabPanel>
                <TabPanel value="3" sx={{p: 0}}><HomePhotos/></TabPanel>
                <TabPanel value="4" sx={{p: 0}}><HomeServices/></TabPanel>
                <TabPanel value="5" sx={{p: 0}}><HomePropertyInstruction/></TabPanel>
            </TabContext>
        </Box>
    </Card>
}

export default HomeTabs;